import React from "react";
import "../styles/Footer.css";

const ORG_NAME = "Gail Thompson Foundation Inc";
const EIN = "39-3904781";
const PHONE_DISPLAY = "978.245.6718";
const PHONE_TEL = "+19782456718";
const SUPPORT_EMAIL = "support@gailthompsonfoundation.com";

const IconInstagram = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5zm0 2a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H7zm5 3.5a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11zm0 2a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7zM18 6.2a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
  </svg>
);

const IconLinkedIn = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M4.98 3.5C4.98 4.88 3.9 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1s2.48 1.12 2.48 2.5zM0 8h5v15H0V8zm7.5 0H12v2.1h.06c.63-1.2 2.17-2.46 4.47-2.46 4.78 0 5.66 3.14 5.66 7.22V23H17v-6.8c0-1.62-.03-3.7-2.25-3.7-2.26 0-2.6 1.76-2.6 3.58V23H7.5V8z"/>
  </svg>
);

const IconFacebook = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M22 12.07C22 6.48 17.52 2 11.93 2 6.35 2 1.87 6.48 1.87 12.07c0 4.99 3.65 9.13 8.43 9.93v-7.03H7.9v-2.9h2.4V9.99c0-2.38 1.42-3.7 3.6-3.7 1.04 0 2.12.19 2.12.19v2.33h-1.2c-1.18 0-1.56.73-1.56 1.49v1.78h2.66l-.43 2.9h-2.23V22c4.78-.8 8.43-4.94 8.43-9.93z"/>
  </svg>
);

function Footer() {
  return (
    <footer className="aa-footer aa-footer--hatched aa-contrast" aria-label="Site footer">
      <div className="aa-footer__brand">
        <img
          className="aa-brand__wordmark"
          src="/img/GTF.png"
          srcSet="/img/GTF.png 1x, /img/GTF.png 2x"
          alt={ORG_NAME}
        />

        <div className="aa-brand__contacts" role="list">
          <a role="listitem" className="contact-link" href={`tel:${PHONE_TEL}`}>
            📞 {PHONE_DISPLAY}
          </a>
          <span className="aa-sep" aria-hidden="true">•</span>
          <a role="listitem" className="contact-link" href={`mailto:${SUPPORT_EMAIL}`}>
            ✉ {SUPPORT_EMAIL}
          </a>
        </div>
      </div>

      <nav className="aa-footer__links" aria-label="Footer navigation">
        <a href="/privacy">Security &amp; Privacy Policy</a>
        <span aria-hidden="true">|</span>
        <a href="/terms">Terms of Use</a>
      </nav>

      <div className="aa-footer__legal">
        <p>
          © {new Date().getFullYear()} {ORG_NAME}. All Rights Reserved &nbsp;|&nbsp;
          {ORG_NAME} is a not-for-profit 501(c)(3) organization. &nbsp;|&nbsp;
          Tax ID Number: {EIN}
        </p>
      </div>

      <div className="aa-footer__socials" role="group" aria-label="Social media">
        <a className="social-btn" href="https://www.instagram.com/gailthompsonfoundation/" target="_blank" rel="noreferrer" aria-label="Instagram">
          <IconInstagram />
        </a>
        <a className="social-btn" href="https://www.linkedin.com/company/gail-thompson-foundation" target="_blank" rel="noreferrer" aria-label="LinkedIn">
          <IconLinkedIn />
        </a>
        <a className="social-btn" href="https://www.facebook.com/profile.php?id=61582453784353" target="_blank" rel="noreferrer" aria-label="Facebook">
          <IconFacebook />
        </a>
      </div>

      <button
        className="aa-footer__back"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        aria-label="Back to top"
      >
        ▲ BACK TO TOP
      </button>
    </footer>
  );
}

export default Footer;
